import { Action } from 'redux'
import { ExerciseType } from 'store/services/Exercise'

export interface Paginated<T> {
  results: Array<T>
  status: {
    total: number
    offset: number
  }
}

export interface ApiRequestParams {
  $skip?: number
  $limit?: number
  $search?: string
  $filter?: string
}

export interface IAction extends Action {
  payload: any
}

interface IExplanation {
  keyword: string
  description: string
}

interface IAssesment {
  overall_score: number
  pronunciation: {
    score: number
    explanation: IExplanation[]
  }
  content: {
    score: number
    explanation: IExplanation[]
  }
}

export interface ScoreResponse {
  assessment: IAssesment
  overall_score: number
  overall_score_grade: Grade
  target_phrase: string
  word_scores: WordScore[]
}

export interface PhonemeScore {
  score: number
  score_grade: Grade
  sounds_like: string
  sounds_like_ipa: string
  phoneme: string
  phoneme_ipa: string
}

export interface WordScore {
  word: string
  score: number
  score_grade: Grade
  is_matched: boolean
  boundaries: {
    start_ms: number | null
    end_ms: number | null
  }
  indices: {
    end: number
    start: number
  }
  phoneme_scores: PhonemeScore[]
  syllable_scores: Array<{
    score: number
    syllable: string
    syllable_ipa: string
    phoneme_scores: PhonemeScore[]
  }>
}

export type Grade = ('A' | 'B' | 'C' | 'D') | string // TODO: remove `string`

export type SectionName = 'get-ready' | 'learn' | 'practice' | 'speaking-challenge'

export type BookSentence = {
  _id: string | undefined
  type: ExerciseType
  text: string
  imageUrl: string | undefined
  isRated: boolean
  sentence: string
  words: { word: string; score: number }[]
  recordingUrl: string
  bookId: string | undefined
  isListening?: boolean
}

export type PaginatedResponse<T> = {
  results: T[]
  status: {
    offset: number
    total: number
  }
}

export enum StudyBuddyMood {
  Idle = 'idle',
  Bored = 'bored',
  Wave = 'wave',
  Correct = 'correct',
  Wrong = 'wrong',
  Excited = 'excited'
}
